// extracted by mini-css-extract-plugin
export default {"bookNowBtn":"BookNowBtn_bookNowBtn__zHuEI","change-color-on-hover":"BookNowBtn_change-color-on-hover__dMluY","button":"BookNowBtn_button__CIMDp"};